// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_person_status.ml",
      113,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "PersonStatus"
                          ]]
                      },
                      "V1"
                    ]]
                },
                "Control"
              ]]
          },
          "Tax"
        ]]
    });

const Tax = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_person_status.ml",
      191,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "PersonStatus"
                    ]]
                },
                "V1"
              ]]
          },
          "Control"
        ]]
    });

const Control = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_person_status.ml",
      267,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "PersonStatus"
              ]]
          },
          "V1"
        ]]
    });

const V1 = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_person_status.ml",
      341,
      12
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "PersonStatus"
        ]]
    });

const PersonStatus = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_person_status.ml",
      411,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.tax.control.v1.PersonStatus";
}

function to_int(param) {
  switch (param) {
    case /* PERSON_STATUS_UNSPECIFIED */0 :
        return 0;
    case /* PERSON_STATUS_SALARY */1 :
        return 10;
    case /* PERSON_STATUS_CONTRACTED */2 :
        return 20;
    case /* PERSON_STATUS_WINNING */3 :
        return 30;
    case /* PERSON_STATUS_PENSION */4 :
        return 40;
    case /* PERSON_STATUS_REMUNERATION_REPO */5 :
        return 50;
    case /* PERSON_STATUS_REMUNERATION_NON_REPO */6 :
        return 60;
    case /* PERSON_STATUS_DIVIDEND */7 :
        return 70;
    case /* PERSON_STATUS_STIPEND */8 :
        return 80;
    case /* PERSON_STATUS_INSURANCE_INCOME */9 :
        return 90;
    case /* PERSON_STATUS_HOUSEHOLD_INCOME */10 :
        return 100;
    case /* PERSON_STATUS_OTHER_TAXABLE_INCOME */11 :
        return 110;
    
  }
}

function from_int_exn(n) {
  if (n >= 51) {
    if (n >= 81) {
      if (n !== 90) {
        if (n !== 100) {
          if (n !== 110) {
            return Ocaml_protoc_plugin__Result.raise({
                        NAME: "Unknown_enum_value",
                        VAL: n
                      });
          } else {
            return /* PERSON_STATUS_OTHER_TAXABLE_INCOME */11;
          }
        } else {
          return /* PERSON_STATUS_HOUSEHOLD_INCOME */10;
        }
      } else {
        return /* PERSON_STATUS_INSURANCE_INCOME */9;
      }
    } else if (n !== 60) {
      if (n !== 70) {
        if (n >= 80) {
          return /* PERSON_STATUS_STIPEND */8;
        } else {
          return Ocaml_protoc_plugin__Result.raise({
                      NAME: "Unknown_enum_value",
                      VAL: n
                    });
        }
      } else {
        return /* PERSON_STATUS_DIVIDEND */7;
      }
    } else {
      return /* PERSON_STATUS_REMUNERATION_NON_REPO */6;
    }
  } else if (n >= 21) {
    if (n !== 30) {
      if (n !== 40) {
        if (n >= 50) {
          return /* PERSON_STATUS_REMUNERATION_REPO */5;
        } else {
          return Ocaml_protoc_plugin__Result.raise({
                      NAME: "Unknown_enum_value",
                      VAL: n
                    });
        }
      } else {
        return /* PERSON_STATUS_PENSION */4;
      }
    } else {
      return /* PERSON_STATUS_WINNING */3;
    }
  } else if (n !== 0) {
    if (n !== 10) {
      if (n >= 20) {
        return /* PERSON_STATUS_CONTRACTED */2;
      } else {
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
      }
    } else {
      return /* PERSON_STATUS_SALARY */1;
    }
  } else {
    return /* PERSON_STATUS_UNSPECIFIED */0;
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn(e);
            });
}

function to_string(param) {
  switch (param) {
    case /* PERSON_STATUS_UNSPECIFIED */0 :
        return "PERSON_STATUS_UNSPECIFIED";
    case /* PERSON_STATUS_SALARY */1 :
        return "PERSON_STATUS_SALARY";
    case /* PERSON_STATUS_CONTRACTED */2 :
        return "PERSON_STATUS_CONTRACTED";
    case /* PERSON_STATUS_WINNING */3 :
        return "PERSON_STATUS_WINNING";
    case /* PERSON_STATUS_PENSION */4 :
        return "PERSON_STATUS_PENSION";
    case /* PERSON_STATUS_REMUNERATION_REPO */5 :
        return "PERSON_STATUS_REMUNERATION_REPO";
    case /* PERSON_STATUS_REMUNERATION_NON_REPO */6 :
        return "PERSON_STATUS_REMUNERATION_NON_REPO";
    case /* PERSON_STATUS_DIVIDEND */7 :
        return "PERSON_STATUS_DIVIDEND";
    case /* PERSON_STATUS_STIPEND */8 :
        return "PERSON_STATUS_STIPEND";
    case /* PERSON_STATUS_INSURANCE_INCOME */9 :
        return "PERSON_STATUS_INSURANCE_INCOME";
    case /* PERSON_STATUS_HOUSEHOLD_INCOME */10 :
        return "PERSON_STATUS_HOUSEHOLD_INCOME";
    case /* PERSON_STATUS_OTHER_TAXABLE_INCOME */11 :
        return "PERSON_STATUS_OTHER_TAXABLE_INCOME";
    
  }
}

function from_string_exn(s) {
  switch (s) {
    case "PERSON_STATUS_CONTRACTED" :
        return /* PERSON_STATUS_CONTRACTED */2;
    case "PERSON_STATUS_DIVIDEND" :
        return /* PERSON_STATUS_DIVIDEND */7;
    case "PERSON_STATUS_HOUSEHOLD_INCOME" :
        return /* PERSON_STATUS_HOUSEHOLD_INCOME */10;
    case "PERSON_STATUS_INSURANCE_INCOME" :
        return /* PERSON_STATUS_INSURANCE_INCOME */9;
    case "PERSON_STATUS_OTHER_TAXABLE_INCOME" :
        return /* PERSON_STATUS_OTHER_TAXABLE_INCOME */11;
    case "PERSON_STATUS_PENSION" :
        return /* PERSON_STATUS_PENSION */4;
    case "PERSON_STATUS_REMUNERATION_NON_REPO" :
        return /* PERSON_STATUS_REMUNERATION_NON_REPO */6;
    case "PERSON_STATUS_REMUNERATION_REPO" :
        return /* PERSON_STATUS_REMUNERATION_REPO */5;
    case "PERSON_STATUS_SALARY" :
        return /* PERSON_STATUS_SALARY */1;
    case "PERSON_STATUS_STIPEND" :
        return /* PERSON_STATUS_STIPEND */8;
    case "PERSON_STATUS_UNSPECIFIED" :
        return /* PERSON_STATUS_UNSPECIFIED */0;
    case "PERSON_STATUS_WINNING" :
        return /* PERSON_STATUS_WINNING */3;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, PersonStatus, {
      name: name,
      to_int: to_int,
      from_int: from_int,
      from_int_exn: from_int_exn,
      to_string: to_string,
      from_string_exn: from_string_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "PersonStatus"
        ]]
    }, V1, {
      PersonStatus: PersonStatus
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "PersonStatus"
              ]]
          },
          "V1"
        ]]
    }, Control, {
      V1: V1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "PersonStatus"
                    ]]
                },
                "V1"
              ]]
          },
          "Control"
        ]]
    }, Tax, {
      Control: Control
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "to_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int"
                                ],
                                [
                                  /* Function */0,
                                  "from_int_exn"
                                ],
                                [
                                  /* Function */0,
                                  "to_string"
                                ],
                                [
                                  /* Function */0,
                                  "from_string_exn"
                                ]
                              ]
                            },
                            "PersonStatus"
                          ]]
                      },
                      "V1"
                    ]]
                },
                "Control"
              ]]
          },
          "Tax"
        ]]
    }, Buhta, {
      Tax: Tax
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
